import { render, staticRenderFns } from "./AddOnsListCertifications.vue?vue&type=template&id=32b8b382&scoped=true&"
import script from "./AddOnsListCertifications.vue?vue&type=script&lang=js&"
export * from "./AddOnsListCertifications.vue?vue&type=script&lang=js&"
import style0 from "./AddOnsListCertifications.vue?vue&type=style&index=0&id=32b8b382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b8b382",
  null
  
)

export default component.exports